import { defineMessages } from 'react-intl';

export const legalHintsMessages = defineMessages({
  PaymentPauseSurcharge: {
    id: 'ic-atom-LegalHints-paymentPauseSurcharge',
    defaultMessage:
      'Für die Zahlpause (erst in 4 Monaten bezahlen) wird ein zusätzlicher Aufschlag von {paymentPauseValuta}% auf den Warenwert berechnet.',
  },
  BasketHint: {
    id: 'ic-atom-LegalHints-basketHint',
    defaultMessage:
      'Bitte beachte, dass die Raten ohne Versandkosten und Speditionsaufschläge ausgewiesen sind. Deine Aufschläge kannst du im Warenkorb unter Prüfen & Bestellen einsehen.',
  },
});
